/// <reference path="./global.d.ts" />
import { useRouter } from 'next/router';
import { useChatbotCore, type UseChatbotCoreOptions } from './useChatbotCore';

export type UseChatbotOptions = Omit<UseChatbotCoreOptions, 'locale'>;

/**
 * Pages Router 版 useChatbot：locale 来自 next/router。
 * App Router 项目（blofin-home）请使用 ./useChatbot.app。
 */
export function useChatbot(options: UseChatbotOptions) {
  const router = useRouter();
  const locale = router.locale ?? 'en';
  return useChatbotCore({ ...options, locale });
}
